import {
  doc,
  collection,
  CollectionReference,
  setDoc
} from 'firebase/firestore'
import { firestore } from '@/modules/firebase'
import { serverTimestamp } from '@/modules/database'

const newsCollection = collection(
  firestore,
  'news'
) as CollectionReference<FeedEntry>

export async function createNewsEntry(
  entryData: Omit<FeedEntry, 'timestamp' | 'id'>
) {
  const docRef = doc(newsCollection)

  return setDoc(docRef, {
    id: docRef.id,
    timestamp: serverTimestamp(),
    ...entryData
  })
}
